export const capitalizeFirstLetter = (value: string): string => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const lowerCaseFirstLetter = (value: string): string => {
  return value.charAt(0).toLowerCase() + value.slice(1)
}

/** Keep only first 8 char from uuid */
export function shortenUUID(uuid: string): string {
  return uuid.substring(0, 8)
}

/**
 * Code-unit order, for anything that ends up in a hash or a stored document. `localeCompare` reads the
 * runtime's ICU data, so two Node builds can disagree on `_`, `-` and case. To order a list by name, use
 * `compareNames` from `./sort`.
 */
export const compareByCodeUnit = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0)
